import { IOrganizationCurrency, IOrganizationCurrencyTableData } from 'types/interfaces';

export const createCurrenciesTableData = (currenciesData: IOrganizationCurrency[]): IOrganizationCurrencyTableData[] =>
    currenciesData?.length
        ? currenciesData.map(
              (
                  {
                      currencyPercentage,
                      tokenName,
                      tokenSymbol,
                      usdValue,
                      tokenIcon,
                      tokenBalance,
                      chainId,
                      chainTitle,
                  }: IOrganizationCurrency,
                  index: number,
              ) => ({
                  currencyPercentage,
                  tokenName,
                  tokenSymbol,
                  usdValue,
                  tokenIcon,
                  tokenBalance,
                  rank: index + 1,
                  chainId,
                  chainTitle,
              }),
          )
        : [];
